import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  verifyDomainModalHeader: {
    defaultMessage: 'Authenticate Domain',
    description: 'Header for the modal to authenticate a domain',
    id: 'VCR76b',
  },
  verifyDomainInstructionsLine1: {
    defaultMessage:
      'To allow ShipStation to send emails on your behalf, create 3 CNAME records using the values provided below in your domain provider DNS settings. Once you have done that, click <b>Check Status</b>.',
    description: 'Instructions telling the user how to verify their domain',
    id: 'u8qJFw',
  },
  verifyDomainInstructionsLine2: {
    defaultMessage:
      'While the TXT record is optional, we’ve provided it for guidance in case you have not set up a DMARC policy for your domain yet. The values provided in this example should be reviewed by your DNS expert or IT support to ensure they align with your domain security settings.',
    description: 'Instructions explaining that the TXT record is optional',
    id: 'zJUWhd',
  },
  learnMoreHere: {
    defaultMessage: 'Learn about domain authentication in ShipStation',
    description: 'Link to an article with more information about domain authentication',
    id: 'twDnLI',
  },
  checkStatusButtonLabel: {
    defaultMessage: 'Check Status',
    description: 'Label for the button to check the authentication status of a domain',
    id: '7qlcxE',
  },
  domainAuthenticationError: {
    defaultMessage: 'Failed to authenticate domain. Please ensure the settings are correct and try again.',
    description: 'Error message indicating that the domain could not be authenticated',
    id: 'VGsFUA',
  },
  dnsLoadingError: {
    defaultMessage: 'Error loading DNS records. Please try again.',
    description: 'Error message indicating that the DNS records could not be loaded',
    id: 'fLM1rr',
  },
  typeColumnHeader: {
    defaultMessage: 'Type',
    description: 'Header for the type column of a table',
    id: 'XKTOO6',
  },
  hostColumnHeader: {
    defaultMessage: 'Host',
    description: 'Header for the host column of a table',
    id: 'hDMG3w',
  },
  dataColumnHeader: {
    defaultMessage: 'Data',
    description: 'Header for the data column of a table',
    id: 'K2awJ3',
  },
  txtType: {
    defaultMessage: 'TXT (optional)',
    description: 'A TXT DNS record type that is optional. TXT should be untranslated',
    id: '0tMhoo',
  },
  advancedOptionsSectionHeader: {
    defaultMessage: 'Advanced Options',
    description: 'Header for the advanced options section',
    id: 'L0vsTy',
  },
  customizeDnsRecordsInstructions: {
    defaultMessage:
      'If you use SendGrid and would like to specify your DNS records, enter the desired values below then click <b>Update DNS Records</b>.',
    description: 'Instructions for customizing DNS records',
    id: 'UN0YyT',
  },
  subdomainLabel: {
    defaultMessage: 'Subdomain',
    description: 'Label for the subdomain field',
    id: 'BozY4s',
  },
  dkimSelectorLabel: {
    defaultMessage: 'DKIM Selector',
    description: 'Label for the DKIM selector field',
    id: 'EkQ0Oa',
  },
  updateDnsRecordsLabel: {
    defaultMessage: 'Update DNS Records',
    description: 'Label for the button to update the DNS records of a domain',
    id: '9CnVoJ',
  },
  updateDomainError: {
    defaultMessage: 'Failed to update domain. Please try again.',
    description: 'Error message indicating that the domain could not be updated',
    id: 'NPMzgp',
  },
  subdomainMaxCharactersValidationError: {
    defaultMessage: 'Subdomain must be {max} characters or less',
    description: 'Error message indicating that the subdomain is too long',
    id: 'DnKu++',
  },
  subdomainAlphanumericValidationError: {
    defaultMessage: 'Subdomain must contain only letters, numbers, and dashes',
    description: 'Error message indicating that the subdomain can only contain letters, numbers, and dashes',
    id: '08yGed',
  },
  dkimSelectorMaxCharactersValidationError: {
    defaultMessage: 'DKIM Selector must be {max} characters or less',
    description: 'Error message indicating that the DKIM selector is too long',
    id: '6ZdNY0',
  },
  dkimSelectorAlphanumericValidationError: {
    defaultMessage: 'DKIM Selector must contain only letters and numbers',
    description: 'Error message indicating that the DKIM selector can only contain letters and numbers',
    id: 'jjzJAp',
  },
});
